import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RootRedirectComponent } from './modules/pages/root-redirect/root-redirect.component';

const routes: Routes = [
  { path: '', component: RootRedirectComponent }
  
]

@NgModule({             
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
